<div class="container">
  <admin-page-headline
    translationPrefix="master-data.headcount-settings"
    [preNavigateBack]="preNavigateBack"></admin-page-headline>
  <admin-navigation-menu-wrapper>
    @if (!headcountSettings) {
      <div class="loading-container">
        <app-loading-screen
          [local]="true"
          [contrast]="false"></app-loading-screen>
      </div>
    }
    <div class="inner-content">
      <div class="content">
        @if (headcountSettings) {
          <div class="cards-container">
            @for (component of settingConfig.items; track component) {
              <coin-v2-card styleVariant="large">
                <div
                  class="title-with-info"
                  header>
                  {{ 'master-data.' + component.title | translate }}
                  <mat-icon matTooltip="{{ 'master-data.' + component.title + '.info-text' | translate }}">
                    info_outline
                  </mat-icon>
                </div>
                <div class="card-content input-container">
                  @for (actionItem of component.content; track actionItem; let i = $index) {
                    <div
                      class="input-row"
                      [ngClass]="{
                        'in-line': i === 0 && isQuestionnaireForGermanWithPartialEvaluationBoolean(actionItem)
                      }">
                      @if (!isQuestionnaireForGermanWithPartialEvaluationBoolean(actionItem)) {
                        <p class="bold head input-text">{{ actionItem.label | translate }}</p>
                      }
                      @if (isQuestionnaireForGermanWithPartialEvaluationBoolean(actionItem)) {
                        <p>
                          {{
                            headcountSettings[actionItem.key]
                              ? (actionItem.label + '-true' | translate)
                              : (actionItem.label + '-false' | translate)
                          }}
                        </p>
                      }
                      <div class="input-edit">
                        @switch (actionItem.type) {
                          @case (editDataTypesEnum.BOOLEAN) {
                            <ng-container
                              *ngTemplateOutlet="
                                boolean;
                                context: { settings: headcountSettings, actionItem }
                              "></ng-container>
                          }
                          @case (editDataTypesEnum.DROPDOWN) {
                            <ng-container
                              *ngTemplateOutlet="
                                dropdown;
                                context: { settings: headcountSettings, actionItem }
                              "></ng-container>
                          }
                          @case (editDataTypesEnum.TEXT) {
                            <ng-container
                              *ngTemplateOutlet="
                                text;
                                context: { settings: headcountSettings, actionItem }
                              "></ng-container>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              </coin-v2-card>
            }
          </div>
        }
      </div>
      <ng-template
        #boolean
        let-settings="settings"
        let-actionItem="actionItem">
        <coin-v2-checkbox
          [matTooltip]="actionItem.tooltip | translate"
          [(ngModel)]="settings[actionItem.key]" />
      </ng-template>
      <ng-template
        #dropdown
        let-settings="settings"
        let-actionItem="actionItem">
        <coin-v2-dropdown
          #search="dropdownSearch"
          style="width: 100%; margin: 10px 0"
          class="custom-input-field"
          matFormFieldClass="shadow"
          required
          [ngModel]="settings[actionItem.key]"
          [dataSource]="getDropdownItems(actionItem)"
          [matTooltip]="actionItem.tooltip | translate"
          (ngModelChange)="settings && (settings[actionItem.key] = $event)">
          @let bindedObjectProperty = getDropdownBindedObjectProperty(actionItem.dropdownType);
          @for (value of search.results(); track value) {
            <ng-template [coinValue]="bindedObjectProperty ? value[bindedObjectProperty] : value">
              {{ displayFn(value) }}
            </ng-template>
          }
        </coin-v2-dropdown>
      </ng-template>
      <ng-template
        #text
        let-settings="settings"
        let-actionItem="actionItem">
        <coin-v2-number-input
          symbol="day(s)"
          [step]="1"
          [placeholder]="headcountSettings ? 'loading' : 'Enter a valid date as number'"
          [ngModel]="settings && settings[actionItem.key]"
          [matTooltip]="actionItem.tooltip | translate"
          (ngModelChange)="settings && (settings[actionItem.key] = $event)"></coin-v2-number-input>
      </ng-template>

      <coin-v2-dialog-footer
        color="white"
        rounding="none">
        <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
      </coin-v2-dialog-footer>

      <ng-template
        #buttonsTemplate
        let-settings="settings">
        <coin-v2-button
          type="primary"
          icon="save"
          iconPos="right"
          [text]="'general.btnSave' | translate"
          (click)="save()"></coin-v2-button>
      </ng-template>
    </div>
  </admin-navigation-menu-wrapper>
</div>
